import React from 'react';
import { faqsRo } from './faqDataRo';
import FaqItemRo from './FaqItemRo';

const FaqListRo = () => (
  <section className="py-20 bg-brand-dark border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <div className="space-y-4">
        {faqsRo.map((faq, i) => (
          <FaqItemRo key={i} faq={faq} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default FaqListRo;